import React, { useState, useEffect } from 'react';
import { InputAdornment, TextField, Tooltip } from '@common-ui/ui';

export default function ImageName({ value = '', onChange = null, disabled = false }) {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    const splitValue = (value ?? '').split('.');
    const beforeDot = splitValue[0];
    setLocalValue(beforeDot);
  }, [value]);

  const handleChange = (evt) => {
    const nextName = evt.target.value;
    setLocalValue(nextName);
    onChange?.(`${nextName}`);
  };

  return (
    <Tooltip title={'Edit Image Name'}>
      <TextField
        style={{ width: '100%' }}
        id="input-image_name"
        label="Image Name"
        value={localValue}
        onChange={handleChange}
        disabled={disabled}
        InputProps={{
          endAdornment: <InputAdornment position="end">{'.IS2'}</InputAdornment>,
        }}
      />
    </Tooltip>
  );
}
